var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('ld-persistent-banner',{attrs:{"error":_vm.isAccessBlocked,"text":_vm.text,"link":_vm.link,"buttonText":_vm.cta}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }